import { CircularProgress as MuiCircularProgress, styled, Theme } from "@mui/material";
import { CircularProgressColor, IStyledCircularProgressProps } from "./types";

const pickColor = (
    theme?: Theme
): Record<CircularProgressColor, { main?: string; buffer?: string }> => ({
    primary: {
        main: (theme as any)?.palette?.primary?.darker,
        buffer: (theme as any)?.palette?.primary?.main ?? (theme as any)?.palette?.primary?.light,
    },
    secondary: {
        main: (theme as any)?.palette?.secondary?.light,
        buffer: (theme as any)?.palette?.secondary?.lighter ?? (theme as any)?.palette?.secondary?.main,
    },
    tertiary: {
        main: (theme as any)?.palette?.tertiary?.main,
        buffer: (theme as any)?.palette?.tertiary?.light,
    },
    quaternary: {
        main: (theme as any)?.palette?.tertiary?.light,
        buffer: (theme as any)?.palette?.tertiary?.lighter ?? (theme as any)?.palette?.tertiary?.main,
    },
    accentInfo: {
        main: (theme as any)?.palette?.accentInfo?.main,
        buffer: (theme as any)?.palette?.accentInfo?.light ?? (theme as any)?.palette?.accentInfo?.main,
    },
    accentSuccess: {
        main: (theme as any)?.palette?.accentSuccess?.main,
        buffer: (theme as any)?.palette?.accentSuccess?.light ?? (theme as any)?.palette?.accentSuccess?.main,
    },
    accentWarning: {
        main: (theme as any)?.palette?.accentWarning?.main,
        buffer: (theme as any)?.palette?.accentWarning?.light ?? (theme as any)?.palette?.accentWarning?.main,
    },
    accentError: {
        main: (theme as any)?.palette?.accentError?.main,
        buffer: (theme as any)?.palette?.accentError?.light ?? (theme as any)?.palette?.accentError?.main,
    },
    neutral: {
        main: (theme as any)?.palette?.neutral?.main,
        buffer:
            (theme as any)?.palette?.neutral?.lighter ??
            (theme as any)?.palette?.neutral?.light ??
            (theme as any)?.palette?.neutral?.main,
    },
});

const StyledCircularProgress = styled(MuiCircularProgress, {
    shouldForwardProp: (prop) => prop !== "customColor",
})<IStyledCircularProgressProps>(({ theme, customColor = "primary" }) => {
    const colorMap = pickColor(theme)[customColor] ?? {};
    const main = colorMap.main ?? (theme as any)?.palette?.primary?.main;

    return {
        color: main,
    };
});

export { StyledCircularProgress, pickColor };

